import { render, staticRenderFns } from "./LegalBasisViewModal.vue?vue&type=template&id=4c79e99c&"
import script from "./LegalBasisViewModal.vue?vue&type=script&lang=js&"
export * from "./LegalBasisViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports